import React, { useState } from "react";
import "../styles/CarTopBar.css";
import { useGame } from "../GameContext";
const buttonIcons = {
  Control: {
    default: "/img/button/control.svg",
    active: "/img/button/control_2.svg",
  },
  Edit: { default: "/img/button/edit.svg", active: "/img/button/edit_2.svg" },
  Debug: {
    default: "/img/button/debug.svg",
    active: "/img/button/debug_2.svg",
  },
  Run: { default: "/img/button/run.svg", active: "/img/button/run_2.svg" },
};
const characterButtonIcons = {
  family: {
    boy1: {
      default: "/img/carrier/buttonCharacters/family/children1.svg",
      pressed: "/img/carrier/buttonCharacters/family/children1_pressed.svg",
    },
    boy2: {
      default: "/img/carrier/buttonCharacters/family/children2.svg",
      pressed: "/img/carrier/buttonCharacters/family/children2_pressed.svg",
    },
    dad: {
      default: "/img/carrier/buttonCharacters/family/dad.svg",
      pressed: "/img/carrier/buttonCharacters/family/dad_pressed.svg",
    },
    mom: {
      default: "/img/carrier/buttonCharacters/family/mom.svg",
      pressed: "/img/carrier/buttonCharacters/family/mom_pressed.svg",
    },
  },
  animal: {
    wolf: {
      default: "/img/carrier/buttonCharacters/animal/wolf.svg",
      pressed: "/img/carrier/buttonCharacters/animal/wolf_pressed.svg",
    },
    goat: {
      default: "/img/carrier/buttonCharacters/animal/goat.svg",
      pressed: "/img/carrier/buttonCharacters/animal/goat_pressed.svg",
    },
    cabbage: {
      default: "/img/carrier/buttonCharacters/animal/cabbage.svg",
      pressed: "/img/carrier/buttonCharacters/animal/cabbage_pressed.svg",
    },
  },
};
interface TopBars {
  GameStyle: "animal" | "family";
}
const TopBar: React.FC<TopBars> = ({ GameStyle }) => {
  const {
    gameMode,
    setGameMode,
    message,
    triggerAction,
    setHelpPanelOpen,
    isMoving,
  } = useGame();

  const [pressedButton, setPressedButton] = useState<string | null>(null);
  const handleModeChange = (newMode: "Control" | "Edit" | "Debug" | "Run") => {
    setGameMode(newMode);
  };
    const handleCharacterClick = (character: string) => {
    if (isMoving) return;
    setPressedButton(character);
    triggerAction(character);
    setTimeout(() => {
      setPressedButton(null);
    }, 150);
  };


  const handleMessageClick = () => {
    if (message && message.includes("Попробуй ещё раз")) {
      triggerAction("restart");
    }
  };

  const renderMessage = () => {
    if (!message) return null;
    if (message.includes("Попробуй ещё раз")) {
      const parts = message.split("Попробуй ещё раз");
      return (
        <span style={{ whiteSpace: "nowrap" }}>
          {parts[0]}
          <span
            style={{
              textDecoration: "underline",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Попробуй ещё раз
          </span>
          {parts[1]}
        </span>
      );
    }
    if (message.includes("Ты переправил всех персонажей! Молодец!")) {
      const parts = message.split("Ты переправил всех персонажей! Молодец!");
      return (
        <span style={{ whiteSpace: "nowrap" }}>
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            Ты переправил всех персонажей! Молодец!
          </span>
          {parts[1]}
        </span>
      );
    }
    return message;
  };

  return (
    <div className="carrier-top-bar-button">
      <div className="carrier-top-bar">
        <div className="carrier-button-setting">
          <img
            className="carrier-icon"
            title="Управление"
            alt = "Управление"
            src={
              gameMode === "Control"
                ? buttonIcons.Control.active
                : buttonIcons.Control.default
            }
            onClick={() => !isMoving && handleModeChange("Control")}
          />
          <img
            className="carrier-icon"
            alt="Программирование"
            title = "Программирование"
            src={
              gameMode === "Edit"
                ? buttonIcons.Edit.active
                : buttonIcons.Edit.default
            }
            onClick={() => !isMoving && handleModeChange("Edit")}
          />
          {gameMode !== "Run" && (
            <img
              className="carrier-icon"
              alt="Отладка"
              title="Отладка"
              src={
                gameMode === "Debug"
                  ? buttonIcons.Debug.active
                  : buttonIcons.Debug.default
              }
              onClick={() => !isMoving && handleModeChange("Debug")}
            />
          )}
          {gameMode !== "Debug" && (
            <img
              className="carrier-icon"
              alt="Запуск"
              title="Запуск"
              src={
                gameMode === "Run"
                  ? buttonIcons.Run.active
                  : buttonIcons.Run.default
              }
              onClick={() => !isMoving && handleModeChange("Run")}
            />
          )}
        </div>

        <div
          className="carrier-message-bar"
          onClick={handleMessageClick}
          style={{
            cursor:
              message && message.includes("Попробуй ещё раз")
                ? "pointer"
                : "default",
            whiteSpace: "nowrap",
          }}
        >
          {renderMessage()}
        </div>
        <img
          className="carrier-icon help"
          alt="Помощь"
          title="Помощь"
          src="/img/help.svg"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>

      {/* Кнопки действий */}

      {gameMode !== "Debug" && gameMode !== "Run" && (
        <div className="carrier-auxButtons" id="edit_buttons">
          <div className="carrier-transButtons">
            <img
              src="/img/button/AB.svg"
              className="carrier-icon"
              alt="AtoB"
              title="Плыть с A на B"
              onClick={() => !isMoving && triggerAction("AB")}
            />
            <img
              src="/img/button/BA.svg"
              className="carrier-icon"
              alt="BtoA"
              title="Плыть с B на C"
              onClick={() => !isMoving && triggerAction("BA")}
            />
          </div>
           {GameStyle === "animal" ? (
            <div className="carrier-persButtons-animal">
              <img
                src={pressedButton === "wolf" 
                  ? "/img/carrier/buttonCharacters/animal/wolf_pressed.svg" 
                  : "/img/carrier/buttonCharacters/animal/wolf.svg"}
                className="carrier-icons"
                alt="wolf"
                title="Волк"
                onClick={() => handleCharacterClick("wolf")}
              />
              <img
                src={pressedButton === "goat" 
                  ? "/img/carrier/buttonCharacters/animal/goat_pressed.svg" 
                  : "/img/carrier/buttonCharacters/animal/goat.svg"}
                className="carrier-icons"
                alt="goat"
                title="Коза"
                onClick={() => handleCharacterClick("goat")}
              />
              <img
                src={pressedButton === "cabbage" 
                  ? "/img/carrier/buttonCharacters/animal/cabbage_pressed.svg" 
                  : "/img/carrier/buttonCharacters/animal/cabbage.svg"}
                className="carrier-icons"
                alt="cabbage"
                title="Капуста"
                onClick={() => handleCharacterClick("cabbage")}
              />
            </div>
          ) : (
            <div className="carrier-persButtons-family">
              <img
                src={pressedButton === "boy1" 
                  ? "/img/carrier/buttonCharacters/family/children1_pressed.svg" 
                  : "/img/carrier/buttonCharacters/family/children1.svg"}
                className="carrier-icons"
                alt="children1"
                title="Сын 1"
                onClick={() => handleCharacterClick("boy1")}
              />
              <img
                src={pressedButton === "boy2" 
                  ? "/img/carrier/buttonCharacters/family/children2_pressed.svg" 
                  : "/img/carrier/buttonCharacters/family/children2.svg"}
                className="carrier-icons"
                alt="children2"
                title="Сын 2"
                onClick={() => handleCharacterClick("boy2")}
              />
              <img
                src={pressedButton === "dad" 
                  ? "/img/carrier/buttonCharacters/family/dad_pressed.svg" 
                  : "/img/carrier/buttonCharacters/family/dad.svg"}
                className="carrier-icons"
                alt="dad"
                title="Папа"
                onClick={() => handleCharacterClick("dad")}
              />
              <img
                src={pressedButton === "mom" 
                  ? "/img/carrier/buttonCharacters/family/mom_pressed.svg" 
                  : "/img/carrier/buttonCharacters/family/mom.svg"}
                className="carrier-icons"
                alt="mom"
                title="Мама"
                onClick={() => handleCharacterClick("mom")}
              />
            </div>
          )}
        </div>
      )}
      {gameMode === "Run" && (
        <div className="carrier-stopButton">
          <img
            src="/img/button/stop.svg"
            className="carrier-icon stop"
            alt="Stop"
            title="Стоп"
            onClick={() =>!isMoving&& triggerAction("stop")}
          />
        </div>
      )}
      {gameMode === "Debug" && (
        <div className="carrier-nextButton">
          <img
            src="/img/button/next.svg"
            className="carrier-icon next"
            alt="Next"
            title="Следующая команда"
            onClick={() => !isMoving && triggerAction("next")}
          />
        </div>
      )}
    </div>
  );
};

export default TopBar;
